// OWNER: AREA-TEMPLATES (templates/*, partials/*). Components go in src/features/templates.
import { createFileRoute } from '@tanstack/react-router'
import { TemplateStudio } from '@/features/templates/studio/TemplateStudio'

export const Route = createFileRoute('/templates/$templateId/')({
  staticData: { fullBleed: true },
  component: TemplateStudioPage,
})

function TemplateStudioPage() {
  const { templateId } = Route.useParams()
  return <TemplateStudio templateId={templateId} />
}
